export default __webpack_public_path__ + "static/thumb-10-c93a359a4346baa2415d75e80677fff1.jpg";